export default "__VITE_ASSET__Qq0ogdLr__"